<template>
  <nav class="level">
    <div class="level-item">
      <div class="control">
        <label class="radio">
          <input
            type="radio"
            value="damage"
            v-model="statsType"
            @change="$emit('change-stats-type', 'damage')"
          />
          Damage
        </label>
        <label class="radio">
          <input
            type="radio"
            value="minimum-damage"
            v-model="statsType"
            @change="$emit('change-stats-type', 'minimum-damage')"
          />
          Minimum Damage
        </label>
      </div>
    </div>
    <div class="level-item">
      <div class="control">
        <label class="radio">
          <input
            type="radio"
            value="graph"
            v-model="displayType"
            @change="$emit('change-display-type', 'graph')"
          />
          Graph
        </label>
        <label class="radio">
          <input
            type="radio"
            value="table"
            v-model="displayType"
            @change="$emit('change-display-type', 'table')"
          />
          Table
        </label>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "DisplayOptionsLevel",
  data() {
    return {
      statsType: "damage",
      displayType: "graph"
    };
  }
};
</script>
